<template>
    <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
            <h3 class="text-themecolor">General Partner
               <span class="card-subtitle" v-if="user.profile">{{user.profile.first_name+' '+user.profile.last_name}} ({{user.email}})</span>
              <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General Partners</span></button>
            </h3>
        </div>
        <div class="container-fluid p-0" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12 col-sm-8">
                    <div class="card">
                        <div class="card-body p-4">
                            <div class="row">
                                <user-sidebar menu="investors" :id="id"></user-sidebar>
                                <div class="col-9 col-sm-9 pta-content-quest">
                                    <h4 class="card-title">Investors
                                        <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showCreatePanel && hasPermission('create-user') && has_uploads" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add Investor</span></button>
                                    </h4>
                                    <transition name="fade" v-if="hasPermission('create-user')">
                                      <div class="card border-bottom" v-if="showCreatePanel">
                                        <div class="card-body p-4" style="background:#efefef;">
                                          <!-- <h4 class="card-title">{{trans('user.add_new_user')}}</h4> -->
                                          <form @submit.prevent="submit" @keydown="userInvestorForm.errors.clear($event.target.name)" autocomplete="off">
                                            <div class="row">
                                              <div class="col-12 col-sm-12">
                                                <div class="row">
                                                  <div class="col-12">
                                                    <div class="form-group">
                                                      <label for="">Investors</label>
                                                      <v-select label="name" track-by="id" v-model="investor" name="investor_id" id="investor_id" :options="investors.data" :placeholder="'Enter investor name to search ...'" :multiple="false" :close-on-select="true" :clear-on-select="false" :showNoOptions="false" :hide-selected="true" placeholder="Enter investor name to search ..." selectLabel="choose" @search-change="val => searchInvestor(val)"></v-select>
                                                      <show-error :form-name="userInvestorForm" prop-name="investor_id"></show-error>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                                            <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                                          </form>
                                        </div>
                                      </div>
                                    </transition>
                                  <div class="card" v-if="user_investors.total">
                                    <div class="card-body" style="padding:0;">
                                      <div class="table-responsive" v-if="hasPermission('list-user') && user_investors.total">
                                        <table class="table table-hover">
                                          <thead>
                                          <tr>
                                            <th scope="col">{{trans('investor.name')}}</th>
                                            <th scope="col" class="table-option"></th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="investor in user_investors.data">
                                            <td v-text="investor.name"></td>
                                            <td class="table-option">
                                              <div class="btn-group">
                                                <button class="btn btn-danger btn-sm" :key="investor.id" v-if="hasPermission('delete-user')" v-confirm="{ok: confirmDelete(investor)}" v-tooltip="'Remove investor'"><i class="fas fa-trash"></i></button>
                                              </div>
                                            </td>
                                          </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else-if="!has_uploads">The user must upload a fact sheet, presentation and their team bios first!</div>
                                  <div v-else>No investors assigned.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <user-summary :user="user"></user-summary>
            </div>
        </div>
    </div>
</template>

<script>
    import userSidebar from './general-partner-sidebar'
    import userSummary from './summary'
    import vSelect from 'vue-multiselect'

    export default {
        components : { userSidebar,userSummary,vSelect },
        data() {
            return {
              showCreatePanel: false,
              id:this.$route.params.id,
              is_premium: 0,
              user: '',
              has_uploads: false,
              investor: '',
              upload_token: '',
              is_sended: false,
              investors: {
                total: 0,
                data: []
              },
              user_investors: {
                total: 0,
                data: []
              },
              userInvestorForm: new Form({
                user_id: '',
                investor_id: '',
                cp_first_name: '',
                cp_last_name: '',
                name: '',
                cp_email: ''
              },true),
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
            axios.get('/api/user/'+this.id)
              .then(response => response.data)
              .then(response => {
                this.user = response.user;
                this.upload_token = response.user.profile.upload_token;
                this.isMinUploads();
              })
              .catch(error => {
                helper.showDataErrorMsg(error);
                this.$router.push('/user/general-partners');
              })

              this.getUserInvestors();
              // this.searchInvestor("A");
        },
        methods: {

          confirmDelete(investor){
            return dialog => this.deleteInvestor(investor);
          },
          deleteInvestor(investor){
             axios.delete('/api/user-investor/'+investor.id)
                .then(response => response.data)
                .then(response => {
                  toastr.success(response.message);
                  this.getUserInvestors();
                }).catch(error => {
              helper.showDataErrorMsg(error);
            });
          },
          hasPermission(permission){
            return helper.hasPermission(permission);
          },
          isMinUploads(){
            axios.get('/api/upload/is-min-uploads?token=' + encodeURI(this.upload_token))
                .then(response => response.data)
                .then(response => {
                  this.has_uploads = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          getUserInvestors(){
            axios.get('/api/user-investors/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.user_investors = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          searchInvestor(name){
            axios.get('/api/investor?name=' + encodeURI(name))
                .then(response => response.data)
                .then(response => {
                  this.investors = response.investors;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          submit(){

            if(!this.is_sended){
              this.is_sended = true;
              this.userInvestorForm.user_id         = this.id;
              this.userInvestorForm.investor_id     = this.investor.id;
              this.userInvestorForm.name            = this.investor.name;
              this.userInvestorForm.cp_first_name   = this.investor.cp_first_name;
              this.userInvestorForm.cp_last_name    = this.investor.cp_last_name;
              this.userInvestorForm.cp_email        = this.investor.cp_email;

              this.userInvestorForm.post('/api/user-investor')
                  .then(response => {
                    toastr.success(response.message);
                    this.investor = '';
                    this.getUserInvestors();
                    this.is_sended = false;
                  })
                  .catch(error => {
                    helper.showErrorMsg(error);
                    this.is_sended = false;
                  });
              }
          }
        }
    }
</script>
